import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/primeng";
import { LocalStorageService } from "ng2-webstorage";
import { MessageService } from "primeng/components/common/messageservice";
import { CourseHService } from "../courseH.service";
import { addSemsubjectModelH } from "./addSemsubject.model";
@Component({
  selector: "semsubjectH",
  templateUrl: "semsubjectH.component.html",
  styleUrls: ["semsubjectH.component.scss"],
})
export class AddsemsubjectHComponent implements OnInit {
  public AddSemsubjectmodel = new addSemsubjectModelH();
  public schoolId: any;
  public department: any;
  // display: boolean = false;
  display = "none";
  display1 = "none";
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public searchString: string;
  public spinnershow: boolean = false;
  public rolesList: any;
  public departmentList: any;
  public info: boolean = false;
  public isList: boolean = true;

  public HigherEdchildcourse: any;
  public HigherEdchildsemester: any;
  public selectedSemester: string = "";
  public ShowModuleSecData: any = [];
  Modeules: any[] = [];
  public CourseSemesterExamId: any;
  public HigherEdchildmodule: any;
  public HigherEdchildexam: any;
  public selectedExam: string = "";
  public selectedCourse: string = "";
  public selectedExamAdd: string = "";
  public Subjectname: string = "";
  





  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private localStorage: LocalStorageService,
    private courseService: CourseHService
  ) {
    this.schoolId = this.localStorage.retrieve("schoolid");
  }

  ngOnInit() {
    this.GetCourseList();
  }

  private GetCourseList() {
    this.courseService.getHigherEdChildCourseList().finally(() => {}).subscribe(
        (response) => {
          this.HigherEdchildcourse = response["items"];
          try {
            this.selectedCourse =  this.HigherEdchildcourse[0].CourseId;
            this.GetSemesterList()
          } catch (error) {
            
          }
          console.log("HigherEdchildcourse", this.HigherEdchildcourse);
        },
        (error) => {
          console.error(error);
        }
      );
  }

  changecourse() {
    console.log("courseT", this.selectedCourse);
    this.GetSemesterList();
  }
 
  /*---------------------------------------------------------------------------------------------------------------*/

  private GetSemesterList() {
    this.courseService
      .getHigherEdChildSemesterList(this.selectedCourse).finally(() => {}).subscribe(
        (response) => {
          this.HigherEdchildsemester = response;
          try {
            this.selectedSemester =  this.HigherEdchildsemester[0].Id;
            this.GetexamList()
          } catch (error) {
            
          }
          console.log("HigherEdchildsemester", this.HigherEdchildsemester);
        },
        (error) => {
          console.error(error);
        }
      );
  }

  changesemester() {
    console.log("semester", this.selectedSemester);
  }
 
  changeexamAdd() {
    console.log("selectedExamAdd", this.selectedExamAdd);
  }



  /*---------------------------------------------------------------------------------------------------------------*/
  private GetexamList(){
    this.courseService.getHigherEdChildExamList(this.selectedCourse,this.selectedSemester).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildexam = response['Value'];
        try {
          this.selectedExam =  this.HigherEdchildexam[0].examid;
          this.GetModuleList();
        } catch (error) {
          
        }
        console.log('HigherEdchildexam',this.HigherEdchildexam)
      },
      error => {
        console.error(error);
      });
  };

  changeexam() {
    console.log("changeexam", this.selectedExam);
  }
  //-------------------------------------------------------------------------------------------------------------

  private GetModuleList(){
    this.courseService.getHigherEdChildSubjectList(this.selectedCourse,this.selectedSemester,this.selectedExam).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildmodule = response['Value'];
        console.log('HigherEdchildmodule',this.HigherEdchildmodule)
      },
      error => {
        console.error(error);
      });
  };
  
  /*---------------------------------------------------------------------------------------------------------------*/


  postSemesterModeules() {

    var payload = {
      Subject: this.Subjectname,
      CourseSemesterExamId: this.selectedExamAdd,
    };
    this.courseService
      .postSemesterModeuls(payload)
      .finally(() => {})
      .subscribe(
        (response) => {
          this.messageService.add({
            severity: "success",
            summary: "Talkative Parents",
            detail: "Semester Modules Added Successfully",
          });
          this.display1 = "none";
          this.GetModuleList()
          // this.GetSemesterTestMapping()
          //  this.getTestData(this.semId)
          console.log(response);
        },
        (error) => {}
      );
  }

  roleinfo() {
    this.info = true;
  }

  editSemsub(semsub) {
    this.departmentList.filter((ele) => {
      if (ele.Id == semsub.Id) {
        this.AddSemsubjectmodel.Subject = semsub.Subject;
        //   this.AddSemsubjectmodel.Id=semsub.Id;
        //    this.AddSemsubjectmodel.SBAccessRankId=Number(semsub.SbAccessRankId);
        // this.display = true;
        this.display = "block";
      }
    });
  }

  addSemsub() {
    this.AddSemsubjectmodel = new addSemsubjectModelH();
    this.display = "block";
    // this.display = true;
  }
  onCloseHandled() {
    this.display = "none";
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/subject/semsubjectH.component.ts